import React from 'react'

export default React.lazy(() => import('./HistoryEmissionStatisticsManagementV2'))
